import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log('Unauthorized, logging out');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const login = (data) => api.post('/Auth/admin-login', data);

export const createStaticContent = (data, config) => {
  const formData = new FormData();
  formData.append('WhatIsFut90', data.WhatIsFut90);
  if (data.VideoFile) {
    formData.append('VideoFile', data.VideoFile);
  }
  return api.post('/admin/static-content', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    ...config,
  });
};

export const updateStaticContent = (id, data, config) => {
  const formData = new FormData();
  formData.append('WhatIsFut90', data.WhatIsFut90);
  if (data.VideoFile) {
    formData.append('VideoFile', data.VideoFile);
  }
  return api.put(`/admin/static-content/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    ...config,
  });
};

export const getStaticContent = () => api.get('/admin/static-content');

// توابع برای تعرفه‌ها
export const getTariffs = () => api.get('/admin/tariffs');

export const createTariff = (tariffDto) =>
  api.post('/admin/tariffs', tariffDto, {
    headers: { 'Content-Type': 'application/json' },
  });

export const updateTariff = (id, tariffDto) =>
  api.put(`/admin/tariffs/${id}`, tariffDto, {
    headers: { 'Content-Type': 'application/json' },
  });

export const deleteTariff = (id) => api.delete(`/admin/tariffs/${id}`);

// توابع برای درباره ما
export const getAboutUs = () => api.get('/admin/about-us');

export const createAboutUs = (aboutUsDto, config) => {
  const formData = new FormData();
  formData.append('AboutText', aboutUsDto.AboutText);
  formData.append('OurStory', aboutUsDto.OurStory);
  formData.append('SuccessfulTransactions', aboutUsDto.SuccessfulTransactions.toString());
  formData.append('YearsOfExperience', aboutUsDto.YearsOfExperience.toString());
  formData.append('SatisfactionRate', aboutUsDto.SatisfactionRate.toString());
  if (aboutUsDto.Image) {
    formData.append('Image', aboutUsDto.Image);
  }
  return api.post('/admin/about-us', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    ...config,
  });
};

export const updateAboutUs = (id, aboutUsDto, config) => {
  const formData = new FormData();
  formData.append('AboutText', aboutUsDto.AboutText);
  formData.append('OurStory', aboutUsDto.OurStory);
  formData.append('SuccessfulTransactions', aboutUsDto.SuccessfulTransactions.toString());
  formData.append('YearsOfExperience', aboutUsDto.YearsOfExperience.toString());
  formData.append('SatisfactionRate', aboutUsDto.SatisfactionRate.toString());
  if (aboutUsDto.Image) {
    formData.append('Image', aboutUsDto.Image);
  }
  return api.put(`/admin/about-us/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    ...config,
  });
};

// توابع برای پیام‌های تماس
export const getContactMessages = () => api.get('/admin/contact-messages');

export const deleteContactMessage = (id) => api.delete(`/admin/contact-messages/${id}`);

// توابع برای سوالات متداول
export const getFaqs = () => api.get('/admin/faqs');

export const getFaq = (id) => api.get(`/admin/faqs/${id}`);

export const createFaq = (faqDto) =>
  api.post('/admin/faqs', faqDto, {
    headers: { 'Content-Type': 'application/json' },
  });

export const updateFaq = (id, faqDto) =>
  api.put(`/admin/faqs/${id}`, faqDto, {
    headers: { 'Content-Type': 'application/json' },
  });

export const deleteFaq = (id) => api.delete(`/admin/faqs/${id}`);


// توابع برای درخواست‌های سکه
export const getCoinRequests = () => api.get('/admin/coin-requests');

export const deleteCoinRequest = (id) => api.delete(`/admin/coin-requests/${id}`);

// توابع برای دسته‌بندی‌های بلاگ
export const getCategories = () => api.get('/admin/blog/categories');

export const createCategory = (categoryDto) =>
  api.post('/admin/blog/category', categoryDto, {
    headers: { 'Content-Type': 'application/json' },
  });

export const updateCategory = (id, categoryDto) =>
  api.put(`/admin/blog/category/${id}`, categoryDto, {
    headers: { 'Content-Type': 'application/json' },
  });

export const deleteCategory = (id) => api.delete(`/admin/blog/category/${id}`);


// توابع برای پست‌های بلاگ
export const getPosts = () => api.get('/admin/blog/posts');

export const createPost = (formData) =>
  api.post('/admin/blog/post', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const updatePost = (id, formData) =>
  api.put(`/admin/blog/post/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deletePost = (id) => api.delete(`/admin/blog/post/${id}`);

// توابع برای نظرات
export const getComments = (status = null) => {
  const params = status ? { status } : {};
  return api.get('/admin/comments', { params });
};

export const changeCommentStatus = (id, statusDto) =>
  api.put(`/admin/comments/${id}/status`, statusDto, {
    headers: { 'Content-Type': 'application/json' },
  });

export const replyToComment = (id, replyDto) =>
  api.put(`/admin/comments/${id}/reply`, replyDto, {
    headers: { 'Content-Type': 'application/json' },
  });

export const deleteComment = (id) => api.delete(`/admin/comments/${id}`);


// توابع برای داشبورد
export const getWidgets = () => api.get('/admin/dashboard/widgets');
export const getRecentComments = () => api.get('/admin/dashboard/recent-comments');
export const getRecentPosts = () => api.get('/admin/dashboard/recent-posts');
export const getRecentContactMessages = () => api.get('/admin/dashboard/recent-contact-messages');

export default api;